import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

(() => {
	const sharebuttons = document.querySelectorAll('.newspage__sharebtn');

	if(sharebuttons.length > 0) {
		sharebuttons.forEach(btn => {
			
			if(!navigator.share) {
				tippy(btn, {
					content: btn.dataset.tooltip,
					trigger: 'click',
					placement: 'bottom',
					onShow(instance) {
						setTimeout(() => {
							instance.hide();
						}, 2000);
					}
				});
			}

			btn.addEventListener('click', () => {
				// navigator.share only works on HTTPS
				if(navigator.share) {
					const title = document.title;
					const url = document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href;
					navigator.share({
						title,
						url
					})
						.catch(console.error);              
				} else {
					// Create dummy element with url value
					const dummyEl = document.createElement('input');
					const url = window.location.href;
					document.body.appendChild(dummyEl);
					dummyEl.value = url;
					dummyEl.select();
					document.execCommand('copy');
					document.body.removeChild(dummyEl);
				}
			});
		});
	}
})();